export default __webpack_public_path__ + "static/media/cuff@2x.85d0f073.webp";